module.exports = __webpack_public_path__ + "img/poker.11b7c397.png";